import './FormValidation.js';
import Swiper from 'swiper/bundle';

const swiperContainer = document.querySelector('.swiper');
if (swiperContainer) {
  const swiper = new Swiper('.swiper', {
    direction: 'horizontal',
    loop: true,

    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    // TODO: tbd
    // autoplay: {
    //   delay: 5000,
    //   pauseOnMouseEnter: true
    // },
  });
}

// MENU AND LOGO

const menuButton = document.querySelector('.menu-button');
const fullscreenMenu = document.querySelector('nav');
const logoContainer = document.querySelector('#fixed-logo');
const pageLogo = logoContainer.querySelector('a.page-logo');
const stickyAppointmentButton = document.querySelector('#sticky-appointment-button');
const headerAppointmentButton = document.querySelector('#header-appointment-button');

window.addEventListener('scroll', () => {
  const scrollY = window.scrollY;

  if (scrollY > 60) {
    pageLogo.classList.add('scrolling');
    menuButton.classList.add('scrolling');
  } else {
    pageLogo.classList.remove('scrolling');
    menuButton.classList.remove('scrolling');
  }
});

let menuOpen = false;

// add padding to fixedHeaderContainer and fullscreenMenu to prevent content shift when menu is opened
const fixedHeaderContainer = document.querySelector('#header-fixed');
const defaultPaddingRight = 30;
const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

menuButton.addEventListener('click', () => {
  menuOpen = !menuOpen;

  if (menuOpen) {
    fullscreenMenu.classList.remove('hidden');
    pageLogo.classList.add('menu-open');
    menuButton.classList.add('menu-open');
    document.body.classList.add('overflow-hidden');
    if (stickyAppointmentButton) {
      stickyAppointmentButton.classList.add('hidden');
    }
    if (headerAppointmentButton) {
      headerAppointmentButton.classList.add('!hidden');
    }

    fixedHeaderContainer.style.paddingRight = `${scrollbarWidth}px`;
    fullscreenMenu.style.paddingRight = `${scrollbarWidth + defaultPaddingRight}px`;
  } else {
    fullscreenMenu.classList.add('hidden');
    pageLogo.classList.remove('menu-open');
    menuButton.classList.remove('menu-open');
    document.body.classList.remove('overflow-hidden');
    if (stickyAppointmentButton) {
      stickyAppointmentButton.classList.remove('hidden');
    }
    if (headerAppointmentButton) {
      headerAppointmentButton.classList.remove('!hidden');
    }

    fixedHeaderContainer.style.paddingRight = '';
    fullscreenMenu.style.paddingRight = '';
  }
});

const accordionItems = document.querySelectorAll('.accordion-item');
accordionItems.forEach(item => {
  const header = item.querySelector('.accordion-item-header');
  const content = item.querySelector('.accordion-item-body');

  header.addEventListener('click', () => {
    const noAnimation = item.classList.contains('no-animation');
    if (noAnimation) {
      return;
    }

    const isOpen = item.classList.contains('open');

    // If other items should be closed, uncomment the following lines:
    // accordionItems.forEach(i => {
    //   i.classList.remove('open');
    //   i.querySelector('.accordion-item-body').style.maxHeight = null;
    // });

    if (!isOpen) {
      item.classList.add('open');
      content.style.maxHeight = `${content.scrollHeight}px`;
    } else {
      // If other items should be closed, remove this else block
      item.classList.remove('open');
      content.style.maxHeight = null;
    }
  });
});
